// Fade-in animation for all custom blocks on scroll.
// Blocks carry the class `block-fade-in`; this observer adds `is-visible` when
// the element enters the viewport, triggering the CSS transition.

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // animate once only
      }
    });
  },
  { threshold: 0, rootMargin: '0px 0px -60px 0px' }
);

document.querySelectorAll('.block-fade-in').forEach((el) => observer.observe(el));
